(function() {
	'use strict';
	angular.module('app.leanProjects')
		.directive('resizeKanbanColumn', resizeKanbanColumn);

	function resizeKanbanColumn($window, $timeout) {
		return {
			link: link
		};

		function link(scope, element, attr) {
			var w = angular.element($window);
			w.bind('resize', function() {
				resizeKanbanColumn();
				scope.$apply();
			});

			function resizeKanbanColumn() {
				var hasEndOfLifeBanner = jQuery('.browserIE11EndOfLifeBanner.show').length !== 0;
				var navHeight = jQuery('.nav.navbar-nav').innerHeight() || 0;
				if (hasEndOfLifeBanner) {
					navHeight += 60;
				}
				var padding = parseInt(jQuery('.embeddedBody').css('padding-top')) * 2;
				var stageHeight = jQuery('.kanban-column-header').innerHeight() ? jQuery('.kanban-column-header').innerHeight() : 32;
				var totalHeight = jQuery('.kanban-column-total').innerHeight() ? jQuery('.kanban-column-total').innerHeight() : 42;
				var titleHeight = jQuery('.newPageTitle').innerHeight();
				var filterHeight = jQuery('.filtersContainer').innerHeight();
				var newHeight = jQuery(window).height() - navHeight - padding - stageHeight - totalHeight - titleHeight - filterHeight - 8;
				jQuery(element).css('height', newHeight + 'px');
			}

			$timeout(function() { resizeKanbanColumn(); });
		}
	}

})();
